import { Typography } from '@mui/material';

export const Footer = () => {
  return (
    <Typography variant="caption" component="div">
      {new Date().getFullYear()} © SH-ITB KFT v1.0.0
    </Typography>
  );
};
